import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import dataV from '@jiaminghi/data-view';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';


// 引入全局css
import './assets/scss/style.scss';


//引入echart
//4.x 引用方式
import * as echarts from 'echarts'


//5.x 引用方式为按需引用
//希望使用5.x版本的话,需要在package.json中更新版本号,并切换引用方式
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

// 全局注册
Vue.use(dataV);
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
